module.exports = __webpack_public_path__ + "img/old_card_barcode.dc6bd2b0.png";